import React from "react";
import { Box, Container, Typography } from "@mui/material";
import styles from "../FooterFAQs/FooterFAQs.module.css";

const FooterFAQsHeader = ({ jsonData }) => {
  return (
  <Container maxWidth="xl">
     <div  style={{ padding: "0 28px" }}>
      <div className={styles.faqsTitle}>
         FAQ
      </div>
        {jsonData?.faqs?.map((faq) => (
          <Box key={faq?.id} className={styles.faqsText}>
            <Typography className={styles.privacyPolicyHead}>
              {faq?.question}
            </Typography>
            <Typography
              className={styles.faqsInformation}
              dangerouslySetInnerHTML={{ __html: faq?.answer }}
            />
          </Box>
        ))}
     </div>
   </Container>
  );
};

export default FooterFAQsHeader;
